import { projects } from 'data/bio';
import ProjectItem from '../ProjectItem';
import styles from './projectssection.module.scss';

const ProjectsSection: React.FC = () => {
  return (
    <section id="projects-section-root" className={styles.projectsSectionRoot}>
      <div className={styles.sectionContainer}>
        <div className={styles.projectsGrid}>
          {projects.projects.map(project => (
            <div key={project.id} className={styles.projectItem}>
              <ProjectItem project={project} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
